import { ResponseModelInterfaceStatic } from "@/service/models/response-model-interface";
import { staticImplements } from "@/utilities/static-implements";
import { XmlElementWrapper } from "@/utilities/xml-helpers/xml-element-wrapper";

@staticImplements<ResponseModelInterfaceStatic>()
export class DrugStudy
{
    public constructor(
        public name: string,
        public authors: string,
        public description: string,
        public references: string[],
    )
    {
    }

    public static makeFromXml(elem: XmlElementWrapper): DrugStudy
    {
        return new this(
            elem.firstChildByTag("studyName").translatedElemValue("name"),
            elem.firstChildByTag("studyAuthors").value(),
            elem.firstChildByTag("description").translatedElemValue("desc"),
            elem.firstChildByTagOrNull("references")?.translatedElemValues("reference") ?? [],
        );
    }
}
